export const DATA_ENRICHMENT = {
    COMPANY_DATA_SEARCH_RESOURCE_NAME: 'DATA_ENRICHMENT_COMPANY_DATA_SEARCH',
    EMAIL_FINDER_RESOURCE_NAME: 'DATA_ENRICHMENT_EMAIL_FINDER',
};
export var ArticleNumber;
(function (ArticleNumber) {
    ArticleNumber["MANAGED_TRIAL"] = "1111";
    ArticleNumber["FREE_TRIAL"] = "9999";
    ArticleNumber["FREE"] = "9998";
    ArticleNumber["LEAD_RESEARCH"] = "1901";
    ArticleNumber["DATA_AGENTS_STARTER_SMALL"] = "1907-starter-small";
    ArticleNumber["DATA_AGENTS_STARTER_LARGE"] = "1907-starter-large";
    ArticleNumber["DATA_AGENTS_CORE"] = "1907-core";
    ArticleNumber["DATA_AGENTS_BUSINESS"] = "1907-business";
    ArticleNumber["DATA_AGENTS_ENTERPRISE"] = "1907-enterprise";
    ArticleNumber["DATA_AGENTS_MAILBOX"] = "3333";
    ArticleNumber["VISIT_REPORT"] = "1903";
    ArticleNumber["VISIT_REPORT_VOICE_AI"] = "1903-voiceai";
    ArticleNumber["VISIT_REPORT_TERMINAL"] = "1905";
    ArticleNumber["VISIT_REPORT_TERMINAL_VOICE_AI"] = "1905-voiceai";
    ArticleNumber["VISIT_REPORT_CONCURRENT"] = "1906";
    ArticleNumber["VISIT_REPORT_CONCURRENT_VOICE_AI"] = "1906-voiceai";
    ArticleNumber["VISIT_REPORT_PEAK"] = "2222";
    ArticleNumber["VISIT_REPORT_PEAK_VOICE_AI"] = "2222-voiceai";
    ArticleNumber["BUSINESS_CARDS"] = "1902";
    ArticleNumber["BUSINESS_CARDS_TEAM"] = "1912";
    ArticleNumber["DATA_ENRICHMENT"] = "1904";
})(ArticleNumber || (ArticleNumber = {}));
/** Article Numbers mapped to names */
export const SUBSCRIPTION_TYPES = new Map([
    [ArticleNumber.MANAGED_TRIAL, { name: 'Managed Trial', nameShort: 'MT' }],
    [ArticleNumber.FREE_TRIAL, { name: 'Free Trial', nameShort: 'FT' }],
    [ArticleNumber.FREE, { name: 'Free', nameShort: 'FR' }],
    [ArticleNumber.LEAD_RESEARCH, { name: 'LeadResearch', nameShort: 'LR' }],
    [ArticleNumber.DATA_AGENTS_STARTER_SMALL, { name: 'DataAgents Starter Small', nameShort: 'DA_S_S' }],
    [ArticleNumber.DATA_AGENTS_STARTER_LARGE, { name: 'DataAgents Starter Large', nameShort: 'DA_S_L' }],
    [ArticleNumber.DATA_AGENTS_CORE, { name: 'DataAgents Core', nameShort: 'DA_CORE' }],
    [ArticleNumber.DATA_AGENTS_BUSINESS, { name: 'DataAgents Business', nameShort: 'DA_BUSINESS' }],
    [ArticleNumber.DATA_AGENTS_ENTERPRISE, { name: 'DataAgents Enterprise', nameShort: 'DA_ENTERPRISE' }],
    [ArticleNumber.DATA_AGENTS_MAILBOX, { name: 'DataAgents Mailbox', nameShort: 'DA_MAILBOX' }],
    [ArticleNumber.VISIT_REPORT, { name: 'VisitReport Named User', nameShort: 'VR' }],
    [ArticleNumber.VISIT_REPORT_VOICE_AI, { name: 'VisitReport Named User + Voice AI', nameShort: 'VR_VOICE_AI' }],
    [ArticleNumber.VISIT_REPORT_TERMINAL, { name: 'VisitReport Terminal', nameShort: 'VRT' }],
    [
        ArticleNumber.VISIT_REPORT_TERMINAL_VOICE_AI,
        { name: 'VisitReport Terminal + Voice AI', nameShort: 'VRT_VOICE_AI' },
    ],
    [ArticleNumber.VISIT_REPORT_CONCURRENT, { name: 'VisitReport Concurrent', nameShort: 'VRC' }],
    [
        ArticleNumber.VISIT_REPORT_CONCURRENT_VOICE_AI,
        { name: 'VisitReport Concurrent + Voice AI', nameShort: 'VRC_VOICE_AI' },
    ],
    [ArticleNumber.VISIT_REPORT_PEAK, { name: 'VisitReport Peak', nameShort: 'VRP' }],
    [ArticleNumber.VISIT_REPORT_PEAK_VOICE_AI, { name: 'VisitReport Peak + Voice AI', nameShort: 'VRP_VOICE_AI' }],
    [ArticleNumber.BUSINESS_CARDS, { name: 'BusinessCards Pro', nameShort: 'BCP' }],
    [ArticleNumber.BUSINESS_CARDS_TEAM, { name: 'BusinessCards Team', nameShort: 'BCT' }],
    [ArticleNumber.DATA_ENRICHMENT, { name: 'DataEnrichment', nameShort: 'DE' }],
]);
export const TERMINAL_SUBSCRIPTION_ARTICLE_NUMBERS = new Set([
    ArticleNumber.VISIT_REPORT_TERMINAL,
    ArticleNumber.VISIT_REPORT_TERMINAL_VOICE_AI,
]);
export const DEFAULT_DATA_AGENTS_CREDITS_BY_ARTICLE_NUMBER = new Map([
    [ArticleNumber.MANAGED_TRIAL, 1_000],
    [ArticleNumber.DATA_AGENTS_STARTER_SMALL, 50_000],
    [ArticleNumber.DATA_AGENTS_STARTER_LARGE, 100_000],
    [ArticleNumber.DATA_AGENTS_CORE, 250_000],
    [ArticleNumber.DATA_AGENTS_BUSINESS, 500_000],
    [ArticleNumber.DATA_AGENTS_ENTERPRISE, 750_000],
]);
export const DATA_AGENTS_ARTICLE_NUMBERS = new Set([
    ArticleNumber.DATA_AGENTS_STARTER_SMALL,
    ArticleNumber.DATA_AGENTS_STARTER_LARGE,
    ArticleNumber.DATA_AGENTS_CORE,
    ArticleNumber.DATA_AGENTS_BUSINESS,
    ArticleNumber.DATA_AGENTS_ENTERPRISE,
]);
/* Collection of all article numbers belonging to subscriptions that has no restrictions regarding license amounts. */
export const UNLIMITED_LICENSES_ARTICLE_NUMBERS = new Set([...Array.from(DATA_AGENTS_ARTICLE_NUMBERS)]);
/*
  Collection of all article numbers belonging to "Concurrent" subscriptions, i.e. subscriptions that allow unlimited
  amount of assigned licenses but have some sort of usage limit tied to the license count.
*/
export const CONCURRENT_ARTICLE_NUMBERS = new Set([
    ArticleNumber.VISIT_REPORT_CONCURRENT,
    ArticleNumber.VISIT_REPORT_CONCURRENT_VOICE_AI,
]);
